import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";
import { DefaultFormSubmissionData, FormSubmissionData, FormSubmissionSchemaFields } from "../formBuilder";

export interface AbstractDetailsData extends FormSubmissionData {
    abstractId: number;
    classificationId: number | null;
    classifications: number | null;
    formId: number;
}

export class AbstractDetails implements FormValidationModel<AbstractDetailsData> {
    public data: AbstractDetailsData;
    public rules: yup.Schema<AbstractDetailsData>;

    public constructor() {
        this.data = {
            abstractId: 0,
            classificationId: null,
            classifications: 0,
            formId: 0,
            ...DefaultFormSubmissionData,
        };
        this.rules = yup.object<AbstractDetailsData>().shape({
            ...FormSubmissionSchemaFields,
            abstractId: yup.number().required().label("Abstract ID").min(0, "Invalid $label"),
            classificationId: yup.number().label("Classification").when(["classifications"], (classifications: number) => {
                if (classifications >= 1)
                    return yup.number().required().nullable(true).label("Classification").min(0, "Invalid $label");
                else
                    return yup.number().nullable(true).label("Classification");
            }),
            classifications: yup.number().nullable(true),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminAbstracts/AbstractDetails.ts